import React, { useEffect } from 'react'
import { ComponentData } from '../data/ComponentContext'
import { Col, Row } from 'react-bootstrap'
import AllCollapseExample from './AllCollapseExample'

function QuantityInput({ className }) {

  const { quantity, setQuantity } = ComponentData()

  return (
    <Col md={12}>
      <div className={className}>
        <div className='component-box input-fields'>
          <Row className="headline_texts">
            <div className="configuration-text">
              <h3>Produktionsvolumen</h3>
            </div>
          </Row>
          <div className='component-box input-fields'>
            <input type="number" value={quantity} onChange={(e) => {
              if (e.target.value >= 0) {
                setQuantity(e.target.value)
              }
            }} />
            <span className='unit-label'>Teile/Jahr</span>
          </div>
          <AllCollapseExample />
        </div>
      </div>
    </Col>
  )
}


export default QuantityInput;
